import { render, staticRenderFns } from "./SupplierGroup.vue?vue&type=template&id=977b9612"
import script from "./SupplierGroup.vue?vue&type=script&lang=js"
export * from "./SupplierGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports